
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/own-a-piece/[asset]",
      function () {
        return require("private-next-pages/own-a-piece/[asset].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/own-a-piece/[asset]"])
      });
    }
  